import { useMemo } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { BUDGET_URL } from "features/budget/budget.sections";
import { getScenarioName } from "features/budget/wizard/state/wizard.selectors";
import {
  OVERVIEW_URL,
  OVERVIEW_BUDGET,
} from "features/overview/state/overview.sections";
import HeaderTitleComponent from "./header-title.component";

function HeaderTitle({ title, backTo }) {
  const location = useLocation();
  const scenarioName = useSelector(getScenarioName);
  const budgetRegexp = useMemo(() => RegExp(`^${BUDGET_URL}`), []);
  const preparerRegexp = useMemo(
    () => RegExp(`^${OVERVIEW_URL}${OVERVIEW_BUDGET.path}`),
    [],
  );

  const text = useMemo(() => {
    if (
      budgetRegexp.test(location.pathname) ||
      preparerRegexp.test(location.pathname)
    ) {
      return scenarioName;
    }
    return title;
  }, [budgetRegexp, location.pathname, preparerRegexp, scenarioName, title]);

  return <HeaderTitleComponent text={text} backTo={backTo} />;
}

HeaderTitle.propTypes = {
  title: PropTypes.string.isRequired,
  backTo: PropTypes.string,
};

HeaderTitle.defaultProps = {
  backTo: null,
};

export default HeaderTitle;
